import { useReducer, useContext, useEffect } from 'react';
import { CollapsibleGroupContext } from './CollapsibleGroupContext.js';

/**
 * An internal hook used to manage the CollapsibleGroup state.
 */
function useCollapsibleGroupState({ accordion }) {
    function reducer(state, action) {
        // CollapsibleGroup manages open/close state only in accordion mode
        if (accordion) {
            if (action.type === 'open') {
                return {
                    ...state,
                    open: action.ref,
                };
            }
            else if (accordion !== 'expand' && action.type === 'close') {
                return {
                    ...state,
                    open: null,
                };
            }
        }
        if (action.type === 'register') {
            return {
                ...state,
                refs: state.refs.includes(action.ref)
                    ? state.refs
                    : [...state.refs, action.ref],
            };
        }
        if (action.type === 'unregister') {
            return {
                ...state,
                refs: state.refs.filter(ref => ref !== action.ref),
            };
        }
        return state;
    }
    return useReducer(reducer, {
        open: undefined,
        refs: [],
    });
}
/**
 * An external hook used by individual Collapsibles to register to
 * a CollapsibleGroup
 *
 * @param ref Reference of the Collapsible element
 * @returns CollapsibleGroup context
 */
function useCollapsibleGroup(ref) {
    const groupContext = useContext(CollapsibleGroupContext);
    const { dispatch } = groupContext !== null && groupContext !== void 0 ? groupContext : {};
    useEffect(() => {
        if (dispatch && ref && 'current' in ref) {
            dispatch({ type: 'register', ref });
        }
        return () => {
            if (dispatch && ref && 'current' in ref) {
                dispatch({ type: 'unregister', ref });
            }
        };
    }, [dispatch, ref]);
    return groupContext;
}

export { useCollapsibleGroup, useCollapsibleGroupState };
//# sourceMappingURL=hooks.js.map
